export default {
  methods: {
    getFiscalYear(date) {
      let localDate = null;
      if ((typeof date).toLowerCase() !== 'date') {
        localDate = new Date(date);
      } else {
        localDate = date;
      }
      const fiscalYear = localDate.getFullYear();
      if (localDate.getMonth() >= 6) {
        return fiscalYear + 1;
      }
      return fiscalYear;
    },
  },
};
